import LocalDbTableAdapter from "@/domains/local-db/lib/LocalDbTableAdapter";
import { getStore } from "@/domains/local-db/account/configure";
import config from "@/domains/local-db/account/sync/config";

const table = new LocalDbTableAdapter(getStore, config.TABLE_NAME);

export default table;
